import React from 'react';
import { injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement   } from 'react-stripe-elements';
import * as Actions from '../../../actions/User/Credit';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class CheckoutForm extends React.Component {
  submitHandling = (e) => {
    this.props.noticeRemoveForCredit()
    e.preventDefault();
    this.props.stripe.createToken().then(result => {
      if (result.error) {
        // ERROR
        this.props.noticeAddForCredit(result.error.message,'error')
        return;
      }
      // ここで取得したトークンをバックエンドに送信して完了！！
        this.props.createCreditCard(result.token)
    });
  }

  componentWillMount = () => {
  }
  render() {
    const elementStyle = {
      base: {
        height: '2rem',
        lineHeight: '2rem',
        width: '100%',
        border: 'solid 2px #DADADA'
      }
    }
    const labelStyle = {
      margin: 0,
      lineHeight: '2rem',
      fontWeight: '500',
      textAlign: 'left'
    }
    return (
      <div className='container text-left'>
        <h2 className='mt0 headline d-block text-center'>クレジットカード情報の登録</h2>
        <form onSubmit={this.submitHandling}>
          <div className='field'>
            <label style={labelStyle}>カード番号</label>
            <CardNumberElement className='number-input' style={elementStyle}
            />
          </div>
          <div className='field'>
            <label style={labelStyle}>有効期限</label>
            <CardExpiryElement style={elementStyle}/>
          </div>
          <div className='field'>
            <label style={labelStyle}>CVC</label>
            <CardCVCElement style={elementStyle}/>
          </div>
          <button className='btn btn-submit mt15 btn-block'>上記内容でカード登録</button>
        </form>
      </div>
    );
  }
}

// export default injectStripe(CheckoutForm);


const mapStateToProps = (state) => {
  return state
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch));


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectStripe(CheckoutForm));

export default withRouter(Container);


// WEBPACK FOOTER //
// ./src/components/User/Credit/CheckoutForm.jsx